import { Gltf } from './GltfTypes';

const EXTENSION_KEY = '_ANIMATION_STATE';

export interface AnimationStateExtras {
  type: string;
  stateMapping: Record<string, string[]>;
}

export function readAnimationStateExtras(json: Gltf): AnimationStateExtras | null {
  const skin = json.skins?.[0];
  if (!skin?.extras?.[EXTENSION_KEY]) return null;
  const raw = skin.extras[EXTENSION_KEY];
  if (!raw || typeof raw !== 'object' || !raw.type || !raw.stateMapping) return null;
  return raw as AnimationStateExtras;
}

export function writeAnimationStateExtras(json: Gltf, extras: AnimationStateExtras | null): Gltf {
  const clone = JSON.parse(JSON.stringify(json)) as Gltf;
  const skin = clone.skins?.[0];
  if (!skin) return clone;

  if (!skin.extras) {
    skin.extras = {};
  }

  if (extras) {
    skin.extras[EXTENSION_KEY] = extras;
  } else {
    delete skin.extras[EXTENSION_KEY];
    if (Object.keys(skin.extras).length === 0) {
      delete skin.extras;
    }
  }

  return clone;
}
